import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  CreatePublicLinkDto,
  EditPublicLinkDto,
  PublicLinkDetailsDto,
  PublicLinkListEntryDto
} from '@simOn/public-link/models';
import { API_URL } from '@simOn/utils/tokens';
import { Observable } from 'rxjs';

/** HTTP client for `api/PublicLink/*` (new public links). */
@Injectable({ providedIn: 'root' })
export class PublicLinkApiService {
  private readonly _http = inject(HttpClient);
  private readonly _baseUrl = `${inject<string>(API_URL)}/PublicLink`;

  /** Details and capabilities of the link sent in the request headers. */
  validate$(): Observable<PublicLinkDetailsDto> {
    return this._http.get<PublicLinkDetailsDto>(`${this._baseUrl}/ValidatePublicLink`);
  }

  /** Increments the entrances counter; call once per browser session. */
  opened$(): Observable<void> {
    return this._http.post<void>(`${this._baseUrl}/PublicLinkOpened`, {});
  }

  /** Returns the JWT of the created link. */
  create$(dto: CreatePublicLinkDto): Observable<string> {
    return this._http.post(`${this._baseUrl}/CreatePublicLink`, dto, { responseType: 'text' });
  }

  getAll$(apartmentId: string): Observable<PublicLinkListEntryDto[]> {
    return this._http.get<PublicLinkListEntryDto[]>(`${this._baseUrl}/GetPublicLinks`, { params: { apartmentId } });
  }

  /** The shareable value: a JWT, or the legacy Base64 JSON for legacy links. */
  getShareValue$(id: string): Observable<string> {
    return this._http.get(`${this._baseUrl}/GetPublicLink`, { params: { Id: id }, responseType: 'text' });
  }

  edit$(dto: EditPublicLinkDto): Observable<void> {
    return this._http.put<void>(`${this._baseUrl}/EditPublicLink`, dto);
  }

  delete$(id: string): Observable<void> {
    return this._http.delete<void>(`${this._baseUrl}/DeletePublicLink`, { params: { Id: id } });
  }
}
